import type { CSSProperties } from 'react';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  style?: CSSProperties;
}

export function DividerView({ orientation = 'horizontal', className, style }: DividerProps) {
  if (orientation === 'vertical') {
    return (
      <div
        className={`w-px self-stretch bg-border${className ? ` ${className}` : ''}`}
        style={style}
      />
    );
  }
  return <hr className={`border-border my-2${className ? ` ${className}` : ''}`} style={style} />;
}
